export function autoFillMEC(days, formData, setFormData) {
    const newDateFields = { 
        ...formData.dateFields, 
        // time_deadline_to_send_contract: formData.dateFields.time_deadline_to_send_contract || { date: '11:59 PM', checked: false, scheduledWithVendor: false },
        // possession_time: formData.dateFields.possession_time || { date: '11:59 PM', checked: false, scheduledWithVendor: false },
        // acceptance_deadline_time: formData.dateFields.acceptance_deadline_time || { date: '11:59 PM', checked: false, scheduledWithVendor: false },
    };

    let daysMapping = {
        time_deadline_to_send_contract: {
            30: "11:59 PM",
            45: "11:59 PM",
            60: "11:59 PM",
        },
        alternative_earnest_money_deadline:  {
            30: "2", 
            45: "3",
            60: "4",       
        },
        record_title_deadline: {
            30: "10",
            45: "14",
            60: "18",
        },
        record_title_objection_deadline: {
            30: "11",
            45: "16",
            60: "22",
        },
        off_record_title_deadline: {
            30: "10",
            45: "14",
            60: "18",
        },
        off_record_title_objection_deadline: {
            30: "11",
            45: "16",
            60: "22",
        },
        title_resolution_deadline: {
            30: "14",
            45: "18",
            60: "26",  
        },
        right_of_first_refusal_deadline: {
            30: "5",
            45: "8",
            60: "12",  
        },
        seller_property_disclosure_deadline: {
            30: "2",
            45: "3",
            60: "4",  
        },
        lead_based_paint_disclosure_deadline: {
            30: "2",
            45: "3",
            60: "4",
        },
        new_loan_application_deadline: {
            30: "2",
            45: "3",
            60: "4",
        },
        new_loan_terms_or_termination_deadline: {
            30: "10",
            45: "14",
            60: "18",  
        },
        new_loan_availability_deadline: {
            30: "22",
            45: "28",
            60: "40",  
        },
        buyers_credit_information_deadline: {
            30: "8",
            45: "12",
            60: "16",            
        },
        disapproval_of_buyers_credit_information_deadline: {
            30: "12",
            45: "16",
            60: "21",
        },
        existing_loan_deadline: {
            30: "8",
            45: "12",
            60: "16",
        },
        existing_loan_termination_deadline: {
            30: "12",
            45: "16",
            60: "21",
        },
        loan_transfer_approval_deadline: {
            30: "21",
            45: "28",
            60: "35",
        },
        seller_or_private_financing_deadline: {
            30: "21",
            45: "28",
            60: "35",
        },
        appraisal_deadline: {
            30: "18",
            45: "24",
            60: "35",
        },
        appraisal_objection_deadline: {
            30: "20",
            45: "26",
            60: "37",
        },
        appraisal_resolution_deadline: {
            30: "22",
            45: "28",
            60: "40",
        },
        new_ilc_or_new_survey_deadline: {
            30: "18",
            45: "24",
            60: "30",
        },
        new_ilc_or_new_survey_objection_deadline: {
            30: "19",
            45: "25",
            60: "32",
        },
        new_ilc_or_new_survey_resolution_deadline: {
            30: "20",
            45: "26",
            60: "34",
        },
        inspection_termination_deadline: {
            30: "10",
            45: "12",
            60: '18',
        },
        inspection_objection_deadline: {
            30: '10',
            45: "12",
            60: "18",
        },
        inspection_resolution_deadline: {
            30: "12",
            45: "14",
            60: "20",
        },
        property_insurance_termination_deadline: {
            30: "21",
            45: "24",
            60: "28",
        },
        due_diligence_documents_delivery_deadline: {
            30: "7",
            45: "10",
            60: "14",
        },
        due_diligence_documents_objection_deadline: {
            30: "8",
            45: "11",
            60: "15",
        },
        due_diligence_documents_resolution_deadline: {
            30: "9",
            45: "12",
            60: "16",
        },
        conditional_sale_deadline: {
            30: "24",
            45: "32",
            60: "40",
        },
        lead_based_paint_termination_deadline: {
            30: '10',
            45: "13",
            60: "17",
        },
        closing_date: {
            30: "30",
            45: "45",
            60: "60",
        },
        possession_date: {
            30: "31",
            45: "46",
            60: "61",
        },
        possession_time: {
            30: "11:59 PM",
            45: "11:59 PM",
            60: "11:59 PM",
        },
        acceptance_deadline_date: {
            30: "3",
            45: "3",
            60: "3",
        },
        acceptance_deadline_time: {
            30: "11:59 PM",
            45: "11:59 PM",
            60: "11:59 PM",
        },
    }; 
    if (formData.isHOA === true) {
        daysMapping.association_document_deadline = {
          30: "10", 
          45: "14", 
          60: "20",
        }; 
        daysMapping.association_documents_termination_deadline = {
          30: "11",
          45: "16",
          60: "24",
        };
      } else {
        daysMapping.association_document_deadline = 'N/A';
        newDateFields.association_document_deadline = { daysFromMEC: 'N/A' };

        daysMapping.association_documents_termination_deadline = 'N/A';
        newDateFields.association_documents_termination_deadline = { daysFromMEC: 'N/A' };
    }
    
      if (formData.addWaterAndMineralDates === true) {
        daysMapping.mineral_rights_examination_deadline = {
          30: "14",
          45: "18",
          60: "24",
        };
        daysMapping.water_rights_examination_deadline = {
            30: "14", 
            45: "18", 
            60: "24",
          }; 
      } else {
        daysMapping.mineral_rights_examination_deadline = 'N/A';
        newDateFields.mineral_rights_examination_deadline = { daysFromMEC: 'N/A' };

        daysMapping.water_rights_examination_deadline = 'N/A';
        newDateFields.water_rights_examination_deadline = { daysFromMEC: 'N/A' };
    }
    // Update newDateFields with daysFromMEC
    for (const key in daysMapping) {
        if (daysMapping[key] !== 'N/A') {
            newDateFields[key] = {
                ...newDateFields[key],
                daysFromMEC: daysMapping[key][days]
            };
        }
    }

    setFormData({ ...formData, dateFields: newDateFields });
}